import * as React from "react";

interface IDataContextProviderProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  children: React.ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DataContext = React.createContext<any>({});

export const useDataContext = () => React.useContext(DataContext);

export const DataContextProvider = (props: IDataContextProviderProps) => (
  <DataContext.Provider value={props.value}>
    {props.children}
  </DataContext.Provider>
);
